export default __webpack_public_path__ + "static/media/fa-light-300.7e7cd493.ttf";